import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        icon: {
            color: theme.palette.secondary[600],
            height: '20px !important',
            width: '20px !important',
        },
        link: {
            textDecoration: 'none !important',
            padding: '0px !important',
        },
    }
})

export default useStyles
